import React from "react";
import "./legal.css";

import data from "../content/legal/impressum.generated.json";

// Impressum. The content is authored as an HTML fragment in
// content/impressum.html and compiled into impressum.generated.json by
// scripts/build-legal.js.
const Impressum = () => {
    return (
        <div className="legal-page">
            <div
                className="legal-content"
                dangerouslySetInnerHTML={{ __html: data.html }}
            ></div>
        </div>
    );
};

export default Impressum;
